module.exports = __webpack_public_path__ + "static/magnifier-e99e07fbb1e7c740421dd859f626f7a7.svg";